module.exports = __webpack_public_path__ + "img/empty-cart.3b4822ce.svg";